import d, { css as n } from "styled-components";
const e = d.div.withConfig({
  displayName: "DropdownPopperArrow",
  componentId: "sc-1ddp8dg-0"
})([""]), i = d.div.withConfig({
  displayName: "DropdownPopper",
  componentId: "sc-1ddp8dg-1"
})(["", " ", ""], ({
  isMenuOpen: o
}) => n(["display:", ";"], o ? "block" : "none"), ({
  popperStyles: o
}) => o && n(o)), r = d.div.withConfig({
  displayName: "Dropdown",
  componentId: "sc-1ddp8dg-2"
})(["position:relative;width:fit-content;"]), t = d.div.withConfig({
  displayName: "DropdownReference",
  componentId: "sc-1ddp8dg-3"
})([""]);
export {
  r as Dropdown,
  i as DropdownPopper,
  e as DropdownPopperArrow,
  t as DropdownReference
};
//# sourceMappingURL=style.es.js.map
